<template>
  <div class="dual-unit-container">
    <TextField
      class="left-field"
      :unit="leftUnit"
      v-model="leftValue"
      @input="leftValueChange"
    ></TextField>
    <span class="or-text">OR</span>
    <TextField
      class="right-field"
      :unit="rightUnit"
      v-model="rightValue"
      @input="rightValueChange"
    ></TextField>
  </div>
</template>

<script>
import TextField from './TextField.vue'

export default {
  name: 'DualUnit',
  props: {
    rightUnit: {
      default: 'cm'
    },
    leftUnit: {
      default: 'inches'
    },
    initialValue: {
      default: NaN
    },
    leftToRightConversion: {
      default: 0.394
    }
  },
  data() {
    return {
      rightValue: 1,
      leftValue: 1
    }
  },
  components: {
    TextField
  },
  methods: {
    leftValueChange() {
      this.rightValue = Math.round(this.leftValue * this.leftToRightConversion)
      this.$emit('valueChanged', this.leftValue, this.rightValue)
    },
    rightValueChange() {
      this.leftValue = Math.round(this.rightValue / this.leftToRightConversion)
      this.$emit('valueChanged', this.leftValue, this.rightValue)
    }
  },
  mounted() {
    if (!isFinite(this.initialValue)) {
      this.leftValue = ''
      this.rightValue = ''
    } else {
      this.leftValue = this.initialValue
      this.rightValue = this.initialValue * this.leftToRightConversion
    }
  }
}
</script>

<style scoped>
.dual-unit-container {
  display: flex;
  flex-direction: row;
}
.left-field {
  flex: 1;
  margin-right: 1%;
  padding-right: 0.5%;
}
.right-field {
  flex: 1;
  margin-left: 1%;
  padding-right: 0.5%;
}
</style>
